import { Box, Button, Stack, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { useAppDispatch } from "../../../app/hooks";
import { useSelector } from "react-redux";
import { retrieveSchoolStudents, schoolStudentsSlice, selectSchoolStudents } from "../../../redux/school/schoolStudentsSlice";
import { classroomInsertStudent } from "../../../redux/classroom/classroomStudentAddSlice";
import { ElementSearchBox } from "../../../features/base/ElementSearchBox";
import { LoadState } from "../../../redux/common";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { StudentInfo } from "../../../redux/student/studentSlice";
import { routeStudentNew } from "../../../routes/student";
import PrizaAvatarGrid, { PrizaAvatarGridItem } from "../../../features/base/grid/PrizaAvatarGrid";
import { useEffect, useState } from "react";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { selectUser } from "../../../redux/user/userSlice";
import { NamedObject } from "../../../redux/object/namedObject";

import PersonAddIcon from "@mui/icons-material/PersonAdd";
import BadgedAvatar from "../../../features/base/BadgedAvatar";
import { assertThumbnailUrl } from "../../../redux/common";

import GridOnIcon from '@mui/icons-material/GridOn';
import DnsIcon from '@mui/icons-material/Dns';

interface PossibleStudentListProps {
    schoolId: string;
    classroomId: string;
}

let searchCount = 0;

const PossibleStudentsList = ({ schoolId, classroomId }: PossibleStudentListProps) => {
    const dispatch = useAppDispatch();
    const user = useSelector(selectUser);
    const schoolStudents = useSelector(selectSchoolStudents);
    const navigate = useNavigate();
    const [filterStudent, setFilterStudent] = useState("");
    const [table, setTable] = useState(true);

    useEffect(() => {
        const request = { schoolId, classroomId, filter: filterStudent };
        dispatch(schoolStudentsSlice.actions.check(request));
        if (schoolStudents.state.state == LoadState.NotStarted && isTokenReady(user)) {
            dispatch(retrieveSchoolStudents({ schoolId: schoolId, classroomId: classroomId, filter: filterStudent }));
        }
    }, [schoolStudents.state.state, user, filterStudent, schoolId, classroomId]);

    const addStudent = () => {
        console.log("New student");
        navigate(routeStudentNew(schoolId, classroomId));
    };

    const list = schoolStudents.list || [];
    const mapped: PrizaAvatarGridItem[] = list.map((item: StudentInfo) => {
        const obj = NamedObject.student(item);
        return {
            image: obj.url,
            title: obj.display,
            subtitle: item.name,
            extra: <Tooltip title="Adicionar aluno a sala de aula">
                <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                    <Button variant="outlined" size="small" color='success' onClick={() => {
                        dispatch(classroomInsertStudent({ classroomId: classroomId, student: item }));
                    }}>
                        <PersonAddIcon />
                    </Button>
                </Box>
            </Tooltip>,
        } as PrizaAvatarGridItem;
    });

        const buildContent = !table ? undefined : () => {
        return <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Aluno</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Nome</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Nascimento</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Matricula</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Adicionar</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.map((item) => {
                        return <TableRow key={item.id} hover
                            // onClick={() => {
                            //     dispatch(studentSlice.actions.clean());
                            //     navigate(routeStudent(schoolId, item.id, classroomId));
                            // }}
                            >
                            <TableCell>
                                <Stack direction="row" alignItems="center">
                                    <BadgedAvatar
                                        title={item.nickname || item.name}
                                        avatar={assertThumbnailUrl(item.url)}
                                        size="32px"
                                        marginRight={1}
                                    />
                                    {item.nickname || item.name}
                                </Stack>
                            </TableCell>
                            <TableCell>{item.name}</TableCell>
                            <TableCell>{item.birthDate}</TableCell>
                            <TableCell>{item.schoolNumber}</TableCell>
                            <TableCell>
                                <Button variant="outlined" size="small" color='success' onClick={() => {
                                    dispatch(classroomInsertStudent({ classroomId: classroomId, student: item }));
                                }}>
                                    <PersonAddIcon />
                                </Button>
                            </TableCell>
                        </TableRow>;
                    })}
                </TableBody>
            </Table>
        </>;
    };

    const buttons = [];
    buttons.push({
        label: table ? <DnsIcon /> : <GridOnIcon />,
        click: () => {
            setTable(!table);
        }
    });
    buttons.push({
        label: <Tooltip title="Adicionar novo aluno">
            <Stack direction="row" alignItems="center" spacing={1}>
                <AddIcon />
                Novo
            </Stack>
        </Tooltip>,
        click: () => {
            addStudent();
        }
    });

    return <PrizaAvatarGrid list={mapped}
        toolbar={{
            label: <Box sx={{ width: { xs: "75%", sm: "100%", height: "100px" } }}>
                <Typography variant="h6" component="div" sx={{ m: 1 }}>
                    Buscar Alunos
                </Typography>
                <ElementSearchBox
                    filter={filterStudent}
                    setFilter={(filter: string) => {
                        setFilterStudent(filter);
                        searchCount++;
                        setTimeout(() => {
                            searchCount--;
                            console.debug(`Search '${filter}'? ${searchCount} = 0 :: ${searchCount == 0}`);
                            if (searchCount == 0) {
                                console.info(`Search '${filter}' by timeout`);
                                dispatch(retrieveSchoolStudents({ schoolId, classroomId, filter: filterStudent }));
                            } else if (searchCount < 0) {
                                console.debug(`Search already done :: ${searchCount}`);
                                searchCount = 0;
                            } else {
                                console.trace(`Search overrided :: ${searchCount}`);
                            }
                        }, 1000);
                    }}
                    placeholder="Procurar aluno"
                    label="search"
                    search={(e: any) => {
                        e.preventDefault();
                        searchCount = 0;
                        dispatch(retrieveSchoolStudents({ schoolId: schoolId, classroomId: classroomId, filter: filterStudent }));
                        console.info(`Search '${filterStudent}' requested`);
                    }}
                    working={schoolStudents.state.state == LoadState.Loading}
                />
            </Box>,
            position: "top",
            buttons: buttons,
        }}
        state={schoolStudents.state}
        retry={() => { dispatch(schoolStudentsSlice.actions.clean()); }}
        buildContent={buildContent}
        messages={{
            empty: "Nenhum aluno para ser incluido a esta sala.",
            error: "Erro ao carregar alunos."
        }}
    />;

};

export default PossibleStudentsList;